<div class="p-grid">
    <div class="p-col-12">
        <p-menubar [model]="menuItems">
            <ng-template pTemplate="start" style="width: 100%;">
                <div style="width: fit-content; float: left;">
                    <div class="reportToggleBtn" (click)="toogleMenuBar()">
                        <i class="pi pi-bars fa-lg" aria-hidden="true"></i>
                    </div>
                    <h3 class="p-mb-0" style="margin: 3px; display: inline-block;">Reports</h3>
                </div>
            </ng-template>
            <ng-template pTemplate="end" style="width: 100%;">
            </ng-template>
        </p-menubar>
    </div>

    <div class="p-col-12 p-lg-2" *ngIf="leftNavigation">
        <div class="card">
            <p-panelMenu styleClass="manualPanel" [model]="configMenu" [style]="{'width':'100%'}"></p-panelMenu>
        </div>
    </div>
    <div class="p-col-12 p-lg-10" [ngClass]="{'p-lg-10':leftNavigation, 'p-lg-12':!leftNavigation}">
        <router-outlet></router-outlet>
    </div>

</div>
